import React, { useState } from 'react';
import { Play, Video } from 'lucide-react';
import { Button } from './ui/button';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  
  // Placeholder - replace with actual YouTube embed ID when available
  const videoId = null; // Example: 'dQw4w9WgXcQ'

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            So funktioniert Firmbay
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            In nur 2 Minuten erfahren Sie, wie einfach der Kauf oder Verkauf einer GmbH mit uns ist.
          </p>
        </div>

        {/* Video Container */}
        <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-blue-900 to-teal-900">
          {videoId && isPlaying ? (
            // Actual YouTube Embed
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
              title="Firmbay Erklärvideo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
            />
          ) : (
            // Placeholder / Thumbnail
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                  backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                }} />
              </div>

              {/* Logo / Icon */}
              <div className="mb-8">
                <div className="w-24 h-24 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center border border-white/20">
                  <Video className="w-12 h-12 text-white/80" />
                </div>
              </div>

              {/* Text */}
              <h3 className="text-2xl md:text-3xl font-bold mb-2 text-center px-4">
                Video folgt in Kürze
              </h3>
              <p className="text-blue-200 text-center max-w-md px-4 mb-8">
                Wir arbeiten gerade an einem informativen Erklärvideo für Sie.
              </p>

              {/* Placeholder Button */}
              <Button 
                size="lg"
                className="bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white border border-white/30"
                disabled
              >
                <Play className="w-5 h-5 mr-2" />
                Demnächst verfügbar
              </Button>

              {/* Decorative Elements */}
              <div className="absolute top-10 left-10 w-20 h-20 border border-white/10 rounded-full" />
              <div className="absolute bottom-10 right-10 w-32 h-32 border border-white/10 rounded-full" />
              <div className="absolute top-1/4 right-1/4 w-4 h-4 bg-teal-400/30 rounded-full" />
              <div className="absolute bottom-1/3 left-1/4 w-3 h-3 bg-blue-400/30 rounded-full" />
            </div>
          )}

          {/* Play Button Overlay (for when video is available) */}
          {videoId && !isPlaying && (
            <button
              onClick={() => setIsPlaying(true)}
              className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/40 transition-colors group"
              aria-label="Video abspielen"
            >
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-white/90 flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                <Play className="w-8 h-8 md:w-10 md:h-10 text-blue-600 ml-1" />
              </div>
            </button>
          )}
        </div>

        {/* Features below video */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
          {[
            { title: 'Schnell', desc: 'In wenigen Tagen zur eigenen GmbH' },
            { title: 'Sicher', desc: 'Geprüfte Gesellschaften ohne Altlasten' },
            { title: 'Persönlich', desc: 'Individuelle Beratung durch Experten' },
          ].map((item, i) => (
            <div key={i} className="text-center">
              <div className="text-lg font-semibold text-gray-900">{item.title}</div>
              <div className="text-gray-600 text-sm">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
